module.exports = __webpack_public_path__ + "static/media/2150_featured.4bfd1109.jpg";